import { MepPlanActivationLevel, ref16TrueValues, ref18TrueValues, type MyEmergencyPlanFormSchema } from '@/features';

export const mepGetDefaultActivationLevel = (values: MyEmergencyPlanFormSchema): MepPlanActivationLevel => {
  let level: MepPlanActivationLevel = 'watch-and-act';

  // Ref 17: IF You are protecting people or animals who need assistance. PRESENT WATCH AND ACT.
  if (values.ref15?.some((value) => ref16TrueValues.includes(value))) {
    level = 'watch-and-act';
  }

  // Ref 19: IF ANIMALS OR LIVESTOCK SELECTED SHOW ADVICE.
  if (values.ref15?.some((value) => ref18TrueValues.includes(value))) {
    level = 'advice';
  }

  // Ref 23 & 36: IF NO OWN RELIABLE TRANSPORT SHOW ADVICE.
  if (values.ref21 === false || values.ref34 === false) {
    level = 'advice';
  }

  // Ref 25: If only one route SHOW ADVICE.
  if (values.ref24 === false) {
    level = 'advice';
  }

  return level;
};
